<template>
  <el-dialog
    v-dialogDrag
    title="编辑黑名单"
    :visible="visible"
    width="60%"
    @open="open"
    @close="close"
    :close-on-click-modal="false"
  >
    <el-form
      v-loading="loading"
      element-loading-text="请稍候..."
      label-width="100px"
      class="operation"
      :model="editForm"
      ref="editForm"
    >
      <el-row>
        <el-col :xs="8" :sm="12">
          <el-form-item label="起始Ip">
            <el-input type="text" size="medium" v-model="editForm.startIp" placeholder="请输入起始Ip"/>
          </el-form-item>
        </el-col>

        <el-col :xs="8" :sm="12">
          <el-form-item label="终止Ip">
            <el-input type="text" size="medium" v-model="editForm.endIp" placeholder="请输入终止Ip"/>
          </el-form-item>
        </el-col>

        <el-col :xs="8" :sm="12">
          <el-form-item label="状态：">
              <el-select
                v-model="editForm.enabled"
                placeholder="请选择"
                size="medium"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
        </el-col>

        <el-col :xs="8" :sm="12">
          <el-form-item label="描述">
            <el-input type="text" size="medium" v-model="editForm.remark" placeholder="请输入描述"/>
          </el-form-item>
        </el-col>
        
        <el-col :xs="24" :sm="22" class="text-right">
          <el-button size="medium" @click="close" type="default">取消</el-button>
          <el-button size="medium" @click="submitForm('form')" type="primary">保存</el-button>
        </el-col>
      </el-row>
    </el-form>
    
  </el-dialog>
</template>

<script>
import dialog from '@/components/mixins/dialog'
import EditorTinymce from '@/components/common/EditorTinymce'
import {} from "./api/index"
export default {
  mixins: [dialog],
  props: {
    editForm: { type: Object | null, required: true, default: null },
  },
  data() {
    return {
      form: {
        
      },
      value: "",
      options: [
        {
          name: "未启用",
          value: "0",
        },
        {
          name: "启用",
          value: "1",
        },
      ],
    };
  },
  methods: {
    submitForm(){
      let data = Object.assign({},this.editForm);
      data.type = 0;
      data.lastUpdTime = '';
      editSysIpBlack(data)
        .then((res) => {
          this.$emit('success');
        })
        .catch((err) => {
          this.loading = false;
            this.$alert("服务器发生错误，请联系系统管理员", "登录失败", {
              type: "error",
            })
        });
    },
  },
  components:{EditorTinymce}
}
</script>
<style scoped>
.text-right{
  text-align:right;
}
</style>


